import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Form, Spinner } from "react-bootstrap";
import TableComponent from '../Table/Table';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';

import RichTextEditor from './RichTextEditor';

import { Editor, EditorState } from 'draft-js';
import 'draft-js/dist/Draft.css';

function EditMailingContent() {

    const [searchParams] = useSearchParams();
    const TemplateId = searchParams.get('id');

    const navigate = useNavigate();
    const [ploading, setPloading] = useState(false);
    const [template, setTemplate] = useState({
        Id: null,
        Language: null,
        FID : null,
        Variables: null
    })

    const columns = React.useMemo(
        () => [
            {
                Header: 'ID',
                accessor: 'id', // accessor is the "key" in the data
            },
            {
                Header: 'Username',
                accessor: 'username', // accessor is the "key" in the data
            },
            {
                Header: 'Email',
                accessor: 'email',
            },
            {
                Header: 'Active',
                accessor: 'active',
            },

        ],
        []
    );
    const [userFilter, setUserFilter] = useState({
        username: ""
    })
    const [loading, setLoading] = useState(false);
    const [mloading, setMloading] = useState(false);

    const [language, setLanguage] = useState("");
    const [languages, setLanguages] = useState([]);
    const [templates, setTemplates] = useState([]);

    const [subject, setSubject] = useState("");
    const [content, setContent] = useState("");

    const StoreUser = useSelector((state) => state.user);
    const [affliatePermission, setAffliatePermission] = useState(false)
    const checkPermission = (user, permission) => {
        var Permissions = user.Permissions;
        if (Permissions && Permissions.length > 0) {
            const index = Permissions.findIndex(per => per === permission)
            if (index != -1) return true;
            else return false;
        }
        return true
    }

    const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty()
    );

    const getEditorContentAsRaw = () => {
        const contentState = editorState.getCurrentContent();
        console.log(JSON.stringify(contentState)); // logs the content in raw format
    };

    const GetLanguages = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllLanguages", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })

        if (response.data.Error == null) {
            setLanguages(response.data.Result)
        }
    }
    const GetTemplates = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllStaticTemplates", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })

        if (response.data.Error == null) {
            setTemplates(response.data.Result);
        }
    }

    useEffect(() => {
        GetLanguages();
        GetTemplates();
    }, []);

    const GetTemplate = async () => {
        setPloading(true);
        const response = await axios.get(window.__CFG.API + "manager/GetMailingTemplate/" + TemplateId, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        });
        setPloading(false);

        if (response.data.Error == null) {
            setTemplate(response.data.Result);
        }
    }

    const EditTemplate = async () => {
        setMloading(true);

        const response = await axios.post(window.__CFG.API + "manager/EditMailingTemplate/" + TemplateId, template, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })

        setMloading(false);

        if(response.data.Error == null) {
            toast.success("Updated Sucessufully", {
                duration: 4000
            });
            navigate("/affiliate/settings/mailing-templates")
        } else {
            toast.error(response.data.Error, {
                duration: 4000
            });
        }
    }

    useEffect(() => {
        GetTemplate();
    }, [])

    const handleEditorChange = (state) => {
        setEditorState(state);
    }

    return (
        <Container>
            <Row >
                <div className='aff-grp-section'>
                    <div className='aff-grp-section-title'>
                        Edit Mailing Template
                    </div>

                    {
                        !ploading ? (
                            <div className="promo-form-wp">
                                <div className="mailing-variables" style={{ display : "flex", alignItems : "center", gap : "5px"}}>
                                    <span>Available Variables: </span>
                                    <div className='variables-list'>
                                        <>{template.Variables != null ? template.Variables.toString() : ""}</>
                                        {/* {
                                            template.Variables != null && template.Variables.map(variable => {
                                                return (
                                                    <span className='variable-item'>{variable}</span>
                                                )
                                            })
                                        } */}
                                    </div>
                                </div>
                                <div className="promo-form">
                                    <div className="promo-lbl">
                                        Name
                                    </div>
                                    <div className="promo-in">
                                        <label>{template.Type}</label>
                                    </div>
                                </div>
                                <div className="promo-form">
                                    <div className="promo-lbl">
                                        Template Foreign ID
                                    </div>
                                    <div className="promo-in">
                                        <Form.Control onChange={e => setTemplate({...template, FID : e.target.value})} value={template.FID} placeholder="Template Foreign ID" style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)", padding: 2, paddingLeft: 10 }} type="text" />
                                    </div>
                                </div>
                                <div className="promo-form">
                                    <div className="promo-lbl">
                                    </div>
                                    <div className="promo-in">
                                        <Button onClick={EditTemplate} disabled={mloading} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp "
                                        >
                                            {
                                                mloading ? (
                                                    <>
                                                        <Spinner size="sm" />
                                                    </>
                                                ) : (
                                                    <>Edit Template</>
                                                )
                                            }
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className='loading-area'>
                                    <Spinner size="sm"></Spinner>
                                </div>
                            </>
                        )
                    }
                </div>
            </Row>


        </Container>
    )
}

export default EditMailingContent